<template>
  <main id="main">
    <div style="height: 45vh" class="bg_light_theme w-100 rounded_div position-relative">
      <div class="w-100 h-100 d-flex justify-content-center align-items-center">
        <img src="@/assets/imgs/ayendaman-pic-2.png" class="logo" alt="">
      </div>
    </div>
    <div class="p-3">
      <p class="text-center font_large bold mt-4">{{ t('otp_code_sent') }}</p>
      <p class="text_color_red text-center mb-6 bold font_small">{{ t('check_spam') }}</p>
      <div class="mb-5">
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="rounded-pill p-3 bg_white shadow_input">
            <img src="@/assets/imgs/email-_3_.svg" class="icon-size-5" alt="">
          </div>
          <input v-model="otp" class="rounded-pill p-4 w-85" type="text" placeholder="کد ارسالی">
        </div>
        <p class="text-center mt-3">{{ timer }}</p>
        <div class="d-flex align-items-center justify-content-around">
          <a href="#" @click.prevent="goBack" class="text-decoration-underline text_color_black">{{ t('correct_email') }}</a>
          <button 
            @click="resendOtp" 
            class="bg-transparent border-0" 
            :class="timer > 0 ? 'text_color_gray cursor-default' : 'text_decoration-underline text_color_black cursor-pointer'"
            :disabled="timer > 0"
          >
            {{ t('resend') }}
          </button>
        </div>
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <button class="button" @click="verifyOtp" :disabled="loading">
          {{ loading ? t('loading') : t('submit_continue') }}
        </button>
      </div>
    </div>
    <div class="w-100 max_width d-flex justify-content-end position-fixed bottom-3 p-3">
      <img src="@/assets/imgs/whatsapp.svg" class="icon-size-8 cursor-pointer" alt="" @click="openWhatsApp">
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'OtpView',
  data() {
    return {
      otp: '',
      timer: 300,
      intervalId: null,
      loading: false
    }
  },
  methods: {
    startTimer() {
      if (this.intervalId) clearInterval(this.intervalId)
      this.intervalId = setInterval(() => {
        if (this.timer > 0) {
          this.timer--
        } else {
          clearInterval(this.intervalId)
        }
      }, 1000)
    },
    async verifyOtp() {
      if (!this.otp) return this.notify(this.t('fill_required'), 'error')
      
      const email = localStorage.getItem('user_email')
      if (!email) return this.$router.push({ name: 'Login' })

      this.loading = true
      try {
        const formData = createFormData({ 
          email: email,
          otp: this.otp 
        })

        const response = await apiClient.post('/check_otp', formData)

        if (response.data.status === 'ok') {
          if (response.data.data && response.data.data.user_id) {
            localStorage.setItem('user_id', response.data.data.user_id)
          } else if (response.data.user_id) {
            localStorage.setItem('user_id', response.data.user_id)
          }
          localStorage.setItem('user_role', 'student')

          if (response.data.event === 'user_exists') {
            this.$router.push({ name: 'Home' })
          } else {
            this.$router.push({ name: 'Register' })
          }
        } else {
          const errMsg = response.data.message ? response.data.message : this.t('error_submit')
          this.notify(errMsg, 'error')
        }
      } catch (error) {
        let message = ''
        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message
        } else {
          message = error.message || this.t('connection_error')
        }
        this.notify(message, 'error')
      } finally {
        this.loading = false
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    async resendOtp() {
      if (this.timer > 0) return

      const email = localStorage.getItem('user_email')
      if (!email) return
      
      try {
        const formData = createFormData({ email: email })
        const response = await apiClient.post('/login_email', formData)
        
        if (response.data.status === 'ok' || response.data === true || response.data.data) {
           this.timer = 300
           this.startTimer()
           if (response.data.data) this.notify(`Debug OTP: ${response.data.data}`, 'info', 10000)
           else this.notify(this.t('sent'), 'success')
        } else {
           const errMsg = response.data.message ? response.data.message : this.t('error_submit')
           this.notify(errMsg, 'error')
        }
      } catch (error) {
        let message = ''
        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message
        } else {
          message = error.message || this.t('connection_error')
        }
        this.notify(message, 'error')
      }
    },
    async openWhatsApp() {
      try {
        const formData = createFormData({ action: 'whatsapp' })
        const response = await apiClient.post('/public_info', formData)
        
        let url = ''
        if (typeof response.data === 'string') {
           url = response.data
        } else if (response.data.data) {
           url = response.data.data
        }
        
        if (url) {
           url = url.replace(/"/g, '')
           window.open(url, '_blank')
        }
      } catch (error) {
        this.notify(error.message, 'error')
      }
    }
  },
  mounted() {
    this.startTimer()
  },
  beforeUnmount() {
    clearInterval(this.intervalId)
  }
}
</script>

<style scoped>
.rounded_div {
  border-bottom-left-radius: 5rem;
  border-bottom-right-radius: 5rem;
}
.logo {
  width: 25rem;
}
.text_color_red {
  color: #FF0000;
}
.text_color_black {
  color: #000;
}
.cursor-default {
  cursor: default;
}
.cursor-pointer {
  cursor: pointer;
}
</style>